import {
  API_ERROR,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  MR_INPUT_CHANGEVALUE,
  MR_SELECT_CHANGEVALUE,
  SI_INPUT_CHANGEVALUE,
  ITEM_QTY_CHANGEVALUE,
  ITEM_UNITES_CHANGEVALUE,
  SI_SELECT_CHANGEVALUE,
  PRODUCTS_REQUEST_LIST,
  PRODUCTS_REQUEST_LIST_SUCCESS,
  PRODUCTS_ROW_REQUEST,
  PRODUCTS_ROW_REQUEST_SUCCESS,
  SELECTED_PRODUCTS_LIST,
  REMOVE_SELECTED_PRODUCT,
  MATERIALREQUEST_ADD,
  MATERIALREQUEST_ADD_SUCCESS,
  MODEL_OPEN,
  MODEL_CLOSE,
  MODEL_LIST_OPEN,
  MODEL_LIST_CLOSE,
  MY_MATERIALREQUEST_LIST,
  MATERIALREQUEST_LIST,
  DEPT_MATERIALREQUEST_LIST,
  ALL_MATERIALREQUEST_LIST,
  MATERIALREQUEST_LIST_COUNT,
  MY_MATERIALREQUEST_LIST_COUNT,
  DEPT_MATERIALREQUEST_LIST_COUNT,
  ALL_MATERIALREQUEST_LIST_COUNT,
  MATERIALREQUEST_LIST_COUNT_SUCCESS,
  GET_USER_DEPARTMENT,
  USER_DEPARTMENT_SUCCESS,
  MATERIALREQUEST_ROW_DATA,
  MATERIALREQUEST_ROW_DATA_SUCCESS,
  MATERIALREQUEST_LIST_SUCCESS,
  ITEM_HOD_APPROVAL,
  MR_ITEM_HOD_APPROVAL,
  ALL_MR_HOD_ITEM_LIST_CHECKED,
  MR_HOD_ITEM_LIST_CHECKED,
  MR_DEPT_HOD_APPROVE_ADD,
  MR_HOD_APPROVE_ADD,
  MT_ROW_LOADING,
  C_PRODUCT_IMAGE,
  C_PRODUCT_CHANGEVALUE,
  C_PRODUCT_SELECT_CHANGEVALUE,
  CHANGE_TOGGALE_TAB,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  LIST_LAYOUT,
  TOGGLE_ITEM_MENU,
  MATERIALREQUEST_DELETE,
  CUSTOM_PRODUCT_ADD,
  CUSTOMPRODUCT_ADD_SUCCESS,
  CHANGE_ITEM_MODEL_OPEN,
  CHANGE_ITEM_MODEL_CLOSE,
  C_PRODUCT_RIGHT_SIDEBAR,
  C_PRODUCT_HIDE_RIGHT_SIDEBAR,
  CHANGE_ACTIVATE_PRODUCT,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  VIEW_LOG_SHOW_RIGHT_SIDEBAR,
  VIEW_LOG_HIDE_RIGHT_SIDEBAR,
  ITEM_TIME_LINE,
  ITEM_TIME_LINE_SUCCESSFUL,
  PI_ITEM_TIME_LINE,
  PO_ITEM_TIME_LINE,
  IGP_ITEM_TIME_LINE,
  PRODUCT_STORE_QTY,
  PRODUCT_STORE_QTY_SUCCESSFUL,
  PDF_DOWNNLOAD,
  CLEAR_DATA,
  PRODUCT_HISTORY,
  PRODUCT_HISTORY_SUCCESSFUL,
  PRODUCT_HISTORY_MODEL_CLOSE,
  MRI_STORE_USER_APPROVAL,
  MRI_STORE_HOD_APPROVAL,
  PRODUCT_ITEM_HISTORY_MODEL_OPEN,
  PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
  MR_ITEM_IMAGES_UPLOAD,
  MR_ITEM_UPDATE_IMAGE,
  MATERIAL_REQUEST_CLOSE,
  MRQ_FOCUS_POST,
} from "./actionTypes";
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const MRInputChangeValue = ({ key, value }) => {
  return {
    type: MR_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};

export const MRSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: MR_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const SIInputChangeValue = ({ key, value, item }) => {
  return {
    type: SI_INPUT_CHANGEVALUE,
    payload: { key, value, item },
  };
};
export const ItemQtyChangeValue = ({ key, value, item, status }) => {
  return {
    type: ITEM_QTY_CHANGEVALUE,
    payload: { key, value, item, status },
  };
};
export const ItemUnitsChangeValue = ({ label, value, item, status }) => {
  return {
    type: ITEM_UNITES_CHANGEVALUE,
    payload: { label, value, item, status },
  };
};
export const SISelecteChangeValue = ({ key, label, key2, value, item }) => {
  return {
    type: SI_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};

export const getAllProducts = (data, clearList) => {
  return {
    type: PRODUCTS_REQUEST_LIST,
    payload: { data, clearList },
  };
};
export const productsRequestListSuccessful = (request) => {
  return {
    type: PRODUCTS_REQUEST_LIST_SUCCESS,
    payload: request,
  };
};
export const getRowProducts = (id) => {
  return {
    type: PRODUCTS_ROW_REQUEST,
    payload: { id },
  };
};
export const productRowSuccessful = (request) => {
  return {
    type: PRODUCTS_ROW_REQUEST_SUCCESS,
    payload: request,
  };
};
export const SelectedProducts = ({ products }) => {
  return {
    type: SELECTED_PRODUCTS_LIST,
    payload: products,
  };
};
export const removeSelectProducts = (data) => {
  return {
    type: REMOVE_SELECTED_PRODUCT,
    payload: data,
  };
};
export const addMaterialRequest = (material, materialId, history, callBack) => {
  return {
    type: MATERIALREQUEST_ADD,
    payload: { material, materialId, history, callBack },
  };
};
export const MaterialRequestAddSuccessful = (response) => {
  return {
    type: MATERIALREQUEST_ADD_SUCCESS,
    payload: response,
  };
};
export const model_open = () => {
  return {
    type: MODEL_OPEN,
    // payload: {  },
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};
export const modelListOpen = (id) => {
  return {
    type: MODEL_LIST_OPEN,
    payload: { id },
  };
};

export const modelListClose = () => {
  return {
    type: MODEL_LIST_CLOSE,
  };
};
export const getMyMRListcount = (data) => {
  return {
    type: MY_MATERIALREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const getDeptMRListcount = (data) => {
  return {
    type: DEPT_MATERIALREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const getMeterialReqListcount = (data) => {
  return {
    type: MATERIALREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const getAllMeterialReqListcount = (data) => {
  return {
    type: ALL_MATERIALREQUEST_LIST_COUNT,
    payload: { data },
  };
};
export const MRListCountSuccessful = (request) => {
  return {
    type: MATERIALREQUEST_LIST_COUNT_SUCCESS,
    payload: request,
  };
};
export const getMyMeterialReqList = (data) => {
  return {
    type: MY_MATERIALREQUEST_LIST,
    payload: { data },
  };
};
export const getMeterialReqList = (data) => {
  return {
    type: MATERIALREQUEST_LIST,
    payload: { data },
  };
};
export const getDetMeterialReqList = (data) => {
  return {
    type: DEPT_MATERIALREQUEST_LIST,
    payload: { data },
  };
};
export const getAllMeterialReqList = (data) => {
  return {
    type: ALL_MATERIALREQUEST_LIST,
    payload: { data },
  };
};
export const materialRequestListSuccessful = (request) => {
  return {
    type: MATERIALREQUEST_LIST_SUCCESS,
    payload: request,
  };
};
export const getUserDepartment = (id) => {
  return {
    type: GET_USER_DEPARTMENT,
    payload: { id },
  };
};
export const UserDepartmentSuccessfull = (response) => {
  return {
    type: USER_DEPARTMENT_SUCCESS,
    payload: response,
  };
};

export const getReqestRowDetails = (id, timeLine = false) => {
  return {
    type: MATERIALREQUEST_ROW_DATA,
    payload: { id, timeLine },
  };
};

export const materialRequestsuccessfull = (response) => {
  return {
    type: MATERIALREQUEST_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};
export const materialRequestDelete = (id) => {
  return {
    type: MATERIALREQUEST_DELETE,
    payload: { id },
  };
};

export const itemHodApproval = (data) => {
  return {
    type: ITEM_HOD_APPROVAL,
    payload: { data },
  };
};
export const MRHodApprovedRequest = (material, history) => {
  return {
    type: MR_HOD_APPROVE_ADD,
    payload: { material, history },
  };
};
export const AllMrHodItemsChecked = (checked) => {
  return {
    type: ALL_MR_HOD_ITEM_LIST_CHECKED,
    payload: { checked },
  };
};
export const MrHODItemsChecked = (checked, item, index) => {
  return {
    type: MR_HOD_ITEM_LIST_CHECKED,
    payload: { checked, item, index },
  };
};
export const MRISUserApproval = (data) => {
  return {
    type: MRI_STORE_USER_APPROVAL,
    payload: { data },
  };
};
export const MRISHodApproval = (data, PIData) => {
  return {
    type: MRI_STORE_HOD_APPROVAL,
    payload: { data, PIData },
  };
};
export const MRitemHodApproval = (data) => {
  return {
    type: MR_ITEM_HOD_APPROVAL,
    payload: { data },
  };
};
export const MRDeptHodApprovedRequest = (material, history) => {
  return {
    type: MR_DEPT_HOD_APPROVE_ADD,
    payload: { material, history },
  };
};

export const materialRequestRowloading = (data) => {
  return {
    type: MT_ROW_LOADING,
    payload: data,
  };
};
export const CProductImage = (data) => {
  return {
    type: C_PRODUCT_IMAGE,
    payload: data,
  };
};
export const CProductChangeValue = ({ key, value }) => {
  return {
    type: C_PRODUCT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const CProductSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: C_PRODUCT_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const AddCustomProduct = (data) => {
  return {
    type: CUSTOM_PRODUCT_ADD,
    payload: { data },
  };
};
export const CostomproductAddSuccessful = (response) => {
  return {
    type: CUSTOMPRODUCT_ADD_SUCCESS,
    payload: { response },
  };
};

export const toggleTab = (tab) => {
  return {
    type: CHANGE_TOGGALE_TAB,
    payload: { tab },
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const ChangeItemModelOpen = (item, MRlevel, PIData = false) => {
  return {
    type: CHANGE_ITEM_MODEL_OPEN,
    payload: { item, MRlevel, PIData },
  };
};
export const ChangeItemModelClose = () => {
  return {
    type: CHANGE_ITEM_MODEL_CLOSE,
    // payload: { item },
  };
};
export const productItemHistoryModelOpen = (data) => {
  return {
    type: PRODUCT_ITEM_HISTORY_MODEL_OPEN,
    payload: { data },
  };
};
export const productItemHistoryModelClose = () => {
  return {
    type: PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
    // payload: { item },
  };
};
export const CPRightSidebar = (item) => {
  return {
    type: C_PRODUCT_RIGHT_SIDEBAR,
    payload: { item },
  };
};

// export const showRightSidebar = () => ({
// 	type: SHOW_RIGHT_SIDEBAR,
// 	payload: null
// });

export const cProducthideRightSidebar = () => ({
  type: C_PRODUCT_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const ProductActivateuccessful = (response) => {
  return {
    type: CHANGE_ACTIVATE_PRODUCT,
    payload: response,
  };
};
export const FiltersShowRightSidebar = (MRFilterlevel) => {
  return {
    type: FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: { MRFilterlevel },
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const viewLogShowRightSidebar = (MRId) => {
  return {
    type: VIEW_LOG_SHOW_RIGHT_SIDEBAR,
    payload: { MRId },
  };
};
export const viewLoghideRightSidebar = () => ({
  type: VIEW_LOG_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const GetItemTimeLine = (MRItemId) => {
  return {
    type: ITEM_TIME_LINE,
    payload: { MRItemId },
  };
};
export const GetItemTimeLineSuccessful = (response) => {
  return {
    type: ITEM_TIME_LINE_SUCCESSFUL,
    payload: response,
  };
};

export const GetPIItemTimeLine = (PIItem) => {
  return {
    type: PI_ITEM_TIME_LINE,
    payload: { PIItem },
  };
};
export const GetPOItemTimeLine = (POItem) => {
  return {
    type: PO_ITEM_TIME_LINE,
    payload: { POItem },
  };
};
export const GetIGPItemTimeLine = (IGPItem) => {
  return {
    type: IGP_ITEM_TIME_LINE,
    payload: { IGPItem },
  };
};
export const getProductStoreQty = (ProductID) => {
  return {
    type: PRODUCT_STORE_QTY,
    payload: { ProductID },
  };
};
export const getProductStoreQtySuccessful = (response) => {
  return {
    type: PRODUCT_STORE_QTY_SUCCESSFUL,
    payload: response,
  };
};
export const getPDFDownload = (MRId) => {
  return {
    type: PDF_DOWNNLOAD,
    payload: { MRId },
  };
};
export const clearData = () => {
  return {
    type: CLEAR_DATA,
  };
};
export const GetProductHistory = (ProductID) => {
  return {
    type: PRODUCT_HISTORY,
    payload: { ProductID },
  };
};
export const ProductHistorySuccessful = (response) => {
  return {
    type: PRODUCT_HISTORY_SUCCESSFUL,
    payload: response,
  };
};
export const productHistoryModel_close = () => {
  return {
    type: PRODUCT_HISTORY_MODEL_CLOSE,
    payload: null,
  };
};
export const uploadMultipleMRItemImages = (mrItemImage, ProductId) => {
  return {
    type: MR_ITEM_IMAGES_UPLOAD,
    payload: { mrItemImage, ProductId },
  };
};
export const UpdateMRImage = (data) => {
  return {
    type: MR_ITEM_UPDATE_IMAGE,
    payload: { data },
  };
};
export const materialRequestClose = (id) => {
  return {
    type: MATERIAL_REQUEST_CLOSE,
    payload: { id },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};


// MRQ Focus Post
export const mrqFocusPost = (id, data) => {
  return {
    type: MRQ_FOCUS_POST,
    payload: { id, data },
  };
};